// Vytvori cookie se zadanou hodnotou a platnosti
export const createCookie = (name: string, value: string, days?: number): void => {
    let expires;

    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    } else {
        expires = '';
    }
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
};

// Vraci hodnotu zadane cookie
export const readCookie = (name: string): string | null => {
    const nameEQ = encodeURIComponent(name) + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
};

// Odstrani zadanou cookie
export const eraseCookie = (name: string): void => {
    createCookie(name, '', -1);
};

// alias ke createCookie
export const setCookie = (name: string, value: string, days: number): void => {
    createCookie(name, value, days);
};

// alias k readCookie
export const getCookie = (name: string): string | null => {
    return readCookie(name);
};
